// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1fP3C","content":"LayoutSettings_content__7NTWK"};